/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: CA
 *| (C) Copyright IBM Corp. 2016, 2017
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([], function() {
	'use strict';
	class CancelDataSourceRefreshAction {

		constructor() {}

		// Called by Glass when actionController is created.
		initialize(context) {
			return context.glassContext.getSvc('.DatasetExecutionService').then((datasetExecutionService) => {
				this.datasetExecutionService = datasetExecutionService;
			});
		}

		/**
		 * Determine when we show/hide the menu item
		 */
		isItemVisible(options) {
			var objectInfo = this._getObjectInfo(options);

			if (!objectInfo) {
				return false;
			}

			if (objectInfo.type !== 'dataSet2') {
				return false;
			}
			return this.datasetExecutionService.isExecuting(objectInfo.id);
		}

		/**
		 * Default action handler
		 */
		onSelectItem(options) {
			var objectInfo = this._getObjectInfo(options);
			if (!objectInfo) {
				return;
			}

			this.datasetExecutionService.cancel({
				'id': objectInfo.id,
				'name': objectInfo.defaultName,
				'glassContext': options.glassContext
			}, true);
		}

		_getObjectInfo(options) {
			if (options && options.target && options.target.activeObject) {
				var aSelectedContext = options.target.activeObject.aSelectedContext;
				if (aSelectedContext.length === 1) {
					return aSelectedContext[0];
				}
			}
			return null;
		}
	}

	return CancelDataSourceRefreshAction;
});
